<div *ngIf="vm" class="container p-0">
  <form *ngIf="vm.formGroup" [formGroup]="vm.formGroup">
    <p class="text-center" mat-dialog-title>Generator Search</p>
    <p class="deploy-generator-header">Generator</p>
    <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
      <mat-label for="generatorIDSearchTerm">Asset ID</mat-label>
      <input #generatorIDAutoTrigger="matAutocompleteTrigger"
             id="generatorIDSearchTerm" formControlName="generatorIDSearchTerm" matInput
             placeholder="QR Code Asset Id - Generator" [matAutocomplete]="generatorIDAuto">
      <mat-autocomplete #generatorIDAuto="matAutocomplete" [displayWith]="getAssetID" (optionSelected)="searchByGeneratorId($event)">
        <mat-option *ngFor="let asset of vm.generatorAssetSearchResult; trackBy: trackByGenerator" [value]="asset">
          <span>
            <span *ngIf="asset.assetId">{{ asset.assetId }} | </span>
            <span *ngIf="asset.localId">{{ asset.localId }} | </span>
            <span *ngIf="asset.generatorId">{{ asset.generatorId }}</span>
          </span>
        </mat-option>
      </mat-autocomplete>
      <button
        aria-label="Open QR scanner"
        class="search-icon"
        color="red"
        mat-mini-fab
        matSuffix
        type="button"
        (click)="openGeneratorScanner()">
        <mat-icon>qr_code_scanner</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-inline-class">
      <mat-label for="serialNumberSearchTerm">Serial Number</mat-label>
      <input id="serialNumberSearchTerm" formControlName="serialNumberSearchTerm" matInput
             placeholder="Serial Number" [matAutocomplete]="serialNumberAuto">
      <mat-autocomplete #serialNumberAuto="matAutocomplete" [displayWith]="getSerialNumber" (optionSelected)="searchBySerialNumber($event)">
        <mat-option *ngFor="let serialNumber of vm.serialNumberSearchResult; trackBy: trackBySerialNumber" [value]="serialNumber">
          <span>{{ serialNumber.generatorSerialNumber }}</span>
        </mat-option>
      </mat-autocomplete>
      <button class="search-icon" color="red" mat-mini-fab matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    <div class="space-adjust"></div>

    <p class="deploy-generator-header">Extended Runtime Fuel Tank</p>
    <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
      <mat-label for="fuelTankIDSearchTerm">Asset ID</mat-label>
      <input #fuelTankIDAutoTrigger="matAutocompleteTrigger"
             id="fuelTankIDSearchTerm" formControlName="fuelTankIDSearchTerm" matInput
             placeholder="QR Code Asset Id - Fuel Tank" [matAutocomplete]="fuelTankIDAuto">
      <mat-autocomplete #fuelTankIDAuto="matAutocomplete" [displayWith]="getAssetID" (optionSelected)="searchByFuelTankId($event)">
        <mat-option *ngFor="let asset of vm.fuelTankAssetSearchResult; trackBy: trackByFuelTank" [value]="asset">
          <span>
            <span *ngIf="asset.assetId">{{ asset.assetId }} | </span>
            <span *ngIf="asset.localId">{{ asset.localId }} | </span>
            <span *ngIf="asset.fuelTankId">{{ asset.fuelTankId }}</span>
          </span>
        </mat-option>
      </mat-autocomplete>
      <button
        aria-label="Open QR scanner"
        class="search-icon"
        color="red"
        mat-mini-fab
        matSuffix
        type="button"
        (click)="openFuelTankScanner()">
        <mat-icon>qr_code_scanner</mat-icon>
      </button>
    </mat-form-field>
    <div class="space-adjust"></div>

    <p class="deploy-generator-header">Comments</p>
    <mat-form-field appearance="outline" class="mat-form-field-inline-class pt-1">
      <mat-label for="comments">Comments</mat-label>
      <input id="comments" matInput formControlName="comments" placeholder="Comments">
    </mat-form-field>

    <div class="d-flex justify-content-center mt-3">
      <mat-dialog-actions>
        <button 
          class="cancel-button-color dialog-action-button"
          mat-dialog-close
          mat-raised-button
          type="button"
          (click)="onCancel()"
        >Close</button>
        <button
          class="confirm-button-color dialog-action-button"
          color="primary"
          mat-raised-button
          [disabled]="vm.deployGeneratorButtonDisabled"
          (click)="deployGenerator()"
        >Deploy</button>
      </mat-dialog-actions>
    </div>
  </form>
</div>
